const DEVICE_IMAGE_OFFSETS = {
    Toki: { x: 2, y: -10, image: [531, 669] },
    Poki: { x: 1.5, y: -3, image: [531, 669] },
    Moki: { x: 0, y: 0, image: [354, 446] },
    woofKit: { x: 1.5, y: -3, image: [531, 669] },
}

export function getDeviceImageOffset(device) {
    return DEVICE_IMAGE_OFFSETS[device] || null
}

export function getDeviceImagePosition(device, boxWidth, boxHeight, scale = 1) {
    const offset = getDeviceImageOffset(device)
    const width = parseFloat(boxWidth)
    const height = parseFloat(boxHeight)
    if (!offset || !width || !height) return 'center'
    const [imageWidth, imageHeight] = offset.image
    const fit = Math.min(width / imageWidth, height / imageHeight)
    const left = (width - imageWidth * fit) / 2 + offset.x * scale
    const top = (height - imageHeight * fit) / 2 + offset.y * scale
    return `${left.toFixed(2)}px ${top.toFixed(2)}px`
}
